import { useState } from "react";
import { Bookmark, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useStore } from "@/lib/store";

export const SaveListButton = ({ items, source, testid = "save-list" }) => {
  const { user } = useStore();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const valid = items.filter((i) => i.product_id || i.product);
  if (!user || user.role !== "buyer" || !valid.length) return null;

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/lists", { name, source, items: valid.map((i) => ({ product_id: i.product_id || i.product.id, qty: i.qty })) });
      toast.success(`Saved "${name}" to your lists`);
      setOpen(false); setName("");
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };

  if (!open) return <button onClick={() => setOpen(true)} data-testid={`${testid}-btn`} className="btn-ghost-b2b !py-2 text-xs"><Bookmark className="h-3.5 w-3.5" /> Save as list</button>;
  return (
    <form onSubmit={save} className="flex items-center gap-2" data-testid={`${testid}-form`}>
      <input autoFocus required value={name} onChange={(e) => setName(e.target.value)} placeholder="List name, e.g. Villa kitchen" data-testid={`${testid}-name`} className="input-b2b !w-48 !py-2 !text-xs" />
      <button type="submit" disabled={busy} data-testid={`${testid}-submit`} className="btn-dark !py-2 text-xs">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Save"}</button>
      <button type="button" onClick={() => setOpen(false)} className="text-xs text-slate-500">Cancel</button>
    </form>
  );
};
